import { publicClient } from "@/constants/contracts";
import { queryOptions } from "@tanstack/react-query";
import { type Address, isAddressEqual } from "viem";

export const getNFTBalanceOptions = (
	type: "ERC721A" | "ERC1155",
	collectionAddress: Address,
	tokenId: string | number,
	address: Address,
) => {
	return queryOptions({
		queryKey: ["nfts", "balance", address, collectionAddress, tokenId],
		queryFn: async () => {
			if (type === "ERC1155") {
				const balance = await publicClient.readContract({
					address: collectionAddress,
					abi: [
						{
							inputs: [
								{ internalType: "address", name: "account", type: "address" },
								{ internalType: "uint256", name: "id", type: "uint256" },
							],
							name: "balanceOf",
							outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
							stateMutability: "view",
							type: "function",
						},
					],
					functionName: "balanceOf",
					args: [address, BigInt(tokenId)],
				});
				return Number(balance);
			}
			if (type === "ERC721A") {
				const owner = await publicClient.readContract({
					address: collectionAddress,
					abi: [
						{
							inputs: [{ name: "tokenId", type: "uint256" }],
							name: "ownerOf",
							outputs: [{ name: "", type: "address" }],
							stateMutability: "view",
							type: "function",
						},
					],
					functionName: "ownerOf",
					args: [BigInt(tokenId)],
				});
				return isAddressEqual(address, owner) ? 1 : 0;
			}
			return 0;
		},
		enabled: !!collectionAddress && !!tokenId.toString() && !!address,
		staleTime: 2 * 1000,
	});
};
